import React from 'react';
import { useChatApiVersion } from '../hooks/useChatApiVersion';
import { forcedChatApiVersion, getChatRollout } from '../services/chatApiVersion';

export interface ChatApiVersionGuardProps {
    // Must drop the app's query cache: v1 and v2 message ids address different rows, and the
    // dashboard persists its cache, so a stale feed from the other version would survive a reload.
    onSwitch: () => void;
}

// Holds anyone who may not switch on the rollout's default, even with another version stored.
export function ChatApiVersionGuard({ onSwitch }: ChatApiVersionGuardProps): null {
    const { version, setVersion } = useChatApiVersion(onSwitch);

    React.useEffect(() => {
        const forced = forcedChatApiVersion(version, getChatRollout());
        if (forced) {
            setVersion(forced);
        }
    }, [version, setVersion]);

    return null;
}
